export default __webpack_public_path__ + "static/media/Advanced Potion Making - Final_16.6008c933.jpg";